var _path, _path2, _linearGradient, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M10 5L8.586 3.586A2 2 0 007.172 3H2a1 1 0 00-1 1v12a1 1 0 001 1h16a1 1 0 001-1V6a1 1 0 00-1-1h-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD75E",
    d: "M10 5L8.586 6.414A2 2 0 017.172 7H1v9a1 1 0 001 1h16a1 1 0 001-1V6a1 1 0 00-1-1h-8z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 17
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ffd75e",
    stopOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M10 5L8.586 6.414A2 2 0 017.172 7H1v9a1 1 0 001 1h16a1 1 0 001-1V6a1 1 0 00-1-1h-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E67628",
    d: "M2 16.5c-.373 0-.71-.142-.973-.367A.988.988 0 002 17h16c.505 0 .905-.38.973-.867-.262.226-.6.367-.973.367H2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#FFF",
    d: "M8.836 6.914L10.75 5H10L8.586 6.414A2 2 0 017.172 7H1v.5h6.422a2 2 0 001.414-.586z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsFolder);
export default __webpack_public_path__ + "static/media/msFolder.a4dac87b78119d814ad6a0379b2e41a4.svg";
export { ForwardRef as ReactComponent };